import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/Main.vue'),
      children: [
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        // =============================================================================
        // PAGE ROUTES
        // =============================================================================
        {
          path: '/:route',
          name: 'page-view',
          component: () => import('@/views/pages/Page.vue'),
          props: true
        },
        {
          path: '/',
          redirect: '/accueil'
        },
      ],
    },
    // REDIRECT IF NOT PAGE FOUND
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // REMOVE INITIAL LOADEr
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router 
